export default __webpack_public_path__ + "static/media/VEB_std.a67128b7.png";